// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import DoubleLeftOutlinedSvg from "@ant-design/icons-svg/lib/asn/DoubleLeftOutlined";
import AntdIcon from "../components/AntdIcon";
const DoubleLeftOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: DoubleLeftOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    DoubleLeftOutlined.displayName = "DoubleLeftOutlined";
}
export default /*#__PURE__*/ React.forwardRef(DoubleLeftOutlined);
